"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objToQueryString = void 0;
function objToQueryString(obj = {}) {
    const v = [];
    Object.keys(obj).forEach((value, index, array) => {
        if (typeof obj[value] !== 'undefined') {
            if (Array.isArray(obj[value])) {
                // 兼容array类型参数only 使用后端为spring java的类型
                v.push(`${value}=${obj[value].join(',')}`);
            }
            else {
                const vv = obj[value];
                v.push(`${value}=${vv !== null && vv !== void 0 ? vv : ''}`);
            }
        }
    });
    return v.join('&');
}
exports.objToQueryString = objToQueryString;
//# sourceMappingURL=obj-to-query-string.js.map